<template>
  <div class="share">
    <div class="share__container">
      <close-button @click="$emit('close')" />

      <div class="share__title">
        Partager l'expérience
      </div>

      <div class="share__links">
        <a
          class="share__link share__link--facebook"
          :href="`https://facebook.com/sharer/sharer.php?u=${shareUrl}`"
          target="_blank"
        >
          Facebook
        </a>
        <a
          class="share__link share__link--twitter"
          :href="`https://twitter.com/intent/tweet/?url=${shareUrl}&text=${shareContent}`"
          target="_blank"
        >
          Twitter
        </a>
        <a
          class="share__link share__link--linkedin"
          :href="`https://www.linkedin.com/shareArticle?url=${shareUrl}&title=${shareTitle}&summary=${shareContent}&source=${shareUrl}&mini=true`"
          target="_blank"
        >
          Linkedin
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton.vue'

export default {
  components: {
    CloseButton
  },

  created () {
    this.shareUrl = encodeURIComponent('https://ratp-poc.preprod.brig.ht')
    this.shareTitle = 'Multiangle'
    this.shareContent = 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.'
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.share
  background-color rgba($colors.white, .5)
  width 100%
  height 100%
  top 0
  left 0
  z-index 20
  position fixed
  position absolute

  &__container
    background: $colors.white
    top 50%
    left 50%
    padding 40px 40px 80px 40px
    width calc(100% - 80px)
    max-width 700px
    position absolute
    box-sizing border-box
    border-radius 20px
    display flex
    flex-direction column
    align-items center
    transform translate(-50%, -50%)
    color: $colors.black
    font-weight bold
    box-shadow 0 10px 30px rgba($colors.black, 0.3)

  &__title
    font-size 24px
    margin 40px 0
    text-align center
    color: $colors.black

  &__links
    display flex

  &__link
    display flex
    flex-direction column
    align-items center
    flex-grow 0
    flex-shrink 0
    max-width 400px

    &::before
      content ''
      width 70px
      height 70px
      border-radius 70px
      background-size 40% 40%
      background-position center center
      background-repeat no-repeat
      display block
      margin-bottom 20px

    &:not(:first-of-type)
      margin-left 40px

    &:not(:last-of-type)
      margin-right 40px

    &--facebook::before
      background-image url(/images/facebook.svg)
      background-color rgb(234, 241, 253)

    &--twitter::before
      background-image url(/images/twitter.svg)
      background-color rgb(234, 246, 253)

    &--linkedin::before
      background-image url(/images/linkedin.svg)
      background-color rgb(241, 247, 252)

</style>
